import { ActionType } from "Infrastructure/Api/ApiCustom";
import {
	DeviceStatus,
	DeviceState,
} from "Infrastructure/Models/Messages/Dto/DeviceStatus";

export type DeviceFormItem = {
	name: string;
	isChecked: boolean;
	isDisabled: boolean;
	deviceStatus: DeviceStatus;
};

export type DeviceForm = {
	devices: DeviceFormItem[];
};

export interface DeviceEnabledDisabledModel {
	deviceName: string;
	isEnabled: boolean;
}

export interface ProductDeviceEnabledDisabledModel
	extends DeviceEnabledDisabledModel {
	isContractCreateEnabled: boolean;
}

export const getDeviceStateColor = (state: DeviceState): string => {
	switch (state) {
		case DeviceState.Connected:
			return "#44b700";
		case DeviceState.Disconnected:
			return "#ffb600";
		default:
			return "#919191";
	}
};

export const getActionTypeDescription = (
	actionType: ActionType,
	shortenDescription = false
): string => {
	switch (actionType) {
		case ActionType.InfoWarningCreate:
			return shortenDescription ? "Založení" : "Založení infolišty";
		case ActionType.InfoWarningDeleteByDescription:
			return shortenDescription ? "Smazání" : "Smazání infolišty";
		case ActionType.CacheRefresh:
			return "Refresh cache";
		case ActionType.SystemSettingSave:
			return shortenDescription ? "Aktualizace" : "Aktualizace system settings";
		case ActionType.FeatureEnableDisable:
			return shortenDescription ? "Zapnutí/Vypnutí" : "Zapnutí/Vypnutí feature";
		case ActionType.FeatureUpdate:
			return shortenDescription ? "Aktualizace" : "Aktualizace feature";
		case ActionType.ProductEnableDisable:
			return shortenDescription
				? "Zapnutí/Vypnutí"
				: "Zapnutí/Vypnutí produktových prvků";
		default:
			return "Neznámá akce";
	}
};
